/*
 *  Copyright (c) 2023. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React, { useEffect } from "react";

import LayoutWbs from "./LpWbsComponents/LayoutWbs";
import SchufaWbsPageMeta from "./SchufaWbsPageMeta";
import WbsTeaserWithCards from "./LpWbsComponents/WbsTeaserWithCards";
import TrustSection from "../../../../../components/Sections/Generic/TrustSection/TrustSection";
import PartnerLogoSection from "../../../../../components/Sections/Generic/PartnerLogoSection/PartnerLogoSection";
import GreyBackgroundWrapper from "../../../../../components/BackgroundWrapper/GreyBackgroundWrapper";
import { wbsTeaserCards } from "../../../../../services/landingPageService";
import LinkedCardBox from "../../../../../components/LinkedCardBox/LinkedCardBox";
import SchufaScandalInfoSectionWbs from "./LpWbsComponents/SchufaScandalInfoSectionWbs";
import accordionContentSchufaWbs from "../../../../../components/ControlledAccordion/accordionContentSchufaWbs";
import { Box, Container } from "@mui/material";
import LegalbirdWbsPartnerSection from "./LpWbsComponents/LegalbirdWbsPartnerSection";
import HowItWorksSectionSchufaWbs from "./LpWbsComponents/HowItWorksSectionSchufaWbs";
import ControlledAccordionSectionSchufa from "./LpWbsComponents/ControlledAccordionSectionSchufa";
import { logout } from "../../../../../store/login/actions";
import SchufaCheckin from "./SchufaCheckin/SchufaCheckin";

const SchufaWbsPage = () => {
  useEffect(() => {
    logout();
  }, []);

  return (
    <LayoutWbs>
      <SchufaWbsPageMeta />
      <WbsTeaserWithCards
        headline={"Illegale Weitergabe von Daten aus Telekommunikationsverträgen an die SCHUFA/CRIF"}
        subHeadline={
          <>
            Danke für dein Interesse an unseren Dienstleistungen bezüglich der illegalen Datenweitergabe. Im Augenblick können wir keine weiteren Mandate
            entgegen nehmen, da wir zunächst die weitere Entwicklung der Rechtslage beobachten und abwarten wollen.
            <br />
            <br />
            Wenn du informiert werden möchtest, sobald wir wieder neue Mandate annehmen, trage gerne unten deine E-Mail-Adresse ein.
          </>
        }
        hasTeaserButton={false}
      >
        <LinkedCardBox linkedCards={wbsTeaserCards} />
      </WbsTeaserWithCards>
      <Container>
        <SchufaCheckin idPrefix={"top"} partner={"wbs"} />
      </Container>
      <PartnerLogoSection partnerName={"wbs"} containerStyle={"settlementContainer"} />
      <GreyBackgroundWrapper>
        <HowItWorksSectionSchufaWbs />
        <SchufaScandalInfoSectionWbs />
        <Box paddingTop={"2rem"}>
          <ControlledAccordionSectionSchufa
            contentList={accordionContentSchufaWbs}
            idPrefix={"top"}
            name={"DismissalFaq"}
            heading={"Häufige Fragen und Antworten"}
          />
        </Box>
      </GreyBackgroundWrapper>
      <LegalbirdWbsPartnerSection />
      <TrustSection />
    </LayoutWbs>
  );
};

export default SchufaWbsPage;
